import React, { useMemo } from 'react';
import SidebarMenu from './SidebarMenu';
import useMensajesNoLeidos from '../../../hooks/useMensajesNoLeidos';

const buildProfessorMenuItems = ({
  hasOpenAIChats = true,
  hasAgentesClasicos = false,
  hasModuloAlumnos = false
} = {}) => {
  return [
    { id: 'dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt', path: '/dashboard' },
    { id: 'mensajes', label: 'Mensajes', icon: 'fas fa-envelope', path: '/mensajes' },
    ...(hasOpenAIChats
      ? [{ id: 'mis-asistentes-openai', label: 'Mis Asistentes OpenAI', icon: 'fas fa-robot', path: '/my-assistants' }]
      : []),
    ...(hasAgentesClasicos
      ? [{ id: 'agentes-clasicos-gpt', label: 'Mis Asistentes IA', icon: 'fas fa-robot', path: '/mis-agentes-clasicos-gpt' }]
      : []),
    ...(hasModuloAlumnos
      ? [{ id: 'aulas', label: 'Aulas estudiantes', icon: 'fas fa-door-open', path: '/my-aulas' }]
      : []),
    { id: 'aulas-docentes', label: 'Aulas docentes', icon: 'fas fa-chalkboard-teacher', path: '/aulas-docentes' },
    { id: 'cursos', label: 'Cursos', icon: 'fas fa-layer-group', path: '/my-cursos' },
  ];
};

const ProfessorMenu = ({ activeId, onNavigate, hasOpenAIChats = true, hasAgentesClasicos = false, hasModuloAlumnos = false, className = '', messageScope = 'colegio' }) => {
  const { count: mensajesNoLeidos } = useMensajesNoLeidos(true, { scope: messageScope });
  const items = useMemo(
    () => buildProfessorMenuItems({ hasOpenAIChats, hasAgentesClasicos, hasModuloAlumnos }).map((item) => (
      item.id === 'mensajes' ? { ...item, badge: mensajesNoLeidos } : item
    )),
    [hasOpenAIChats, hasAgentesClasicos, hasModuloAlumnos, mensajesNoLeidos]
  );

  return (
    <SidebarMenu
      items={items}
      activeId={activeId}
      onNavigate={onNavigate}
      className={className}
    />
  );
};

export { buildProfessorMenuItems };
export default ProfessorMenu;
